export const getDocumentalType = (idNumType: any) => {
    switch (idNumType) {
        case "CO1C":
            return "Cédula";
        case "CO1W":
            return "Permiso de Protección Temporal";
        case "CO1L":
            return "Registro Civil de Nacimiento (NUIP)";
        case "CO1E":
            return "Cédula de Extranjería";
        case "CO1P":
            return "Pasaporte";
        case "CO1V":
            return "Permiso Especial de Permanencia";
        case "CO1T":
            return "Tarjeta de Identidad";
        default:
            return "";
           
    }
};
